import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { conditionActions } from "../../../../../store/actions/cms/condition.action";
import { DragDropContext } from "react-beautiful-dnd";
import { Container } from "reactstrap";
import PostFormContent from "./PostFormContent";
import TemplateWrapper from "../../../template/containers/TemplateLayout/TemplateWrapper";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import { SplashScreen } from "../../../../components/UI/SplashScreen/SplashScreen";
import { attendeeActions } from "../../../../../store/actions/attendee/attendee.action";
import { getKey } from "../../../../../helpers/UrlHelper";
import { deepClone } from "../../../../../helpers/objectHelper";
import { NotAuthourized } from "../../../../components/NotAuthorized";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";

class PostFormLayout extends React.Component {
  state = {
    loaded: false,
    surveyCode: "",
    badgeNo: "",
    disabled: false,
    paramHandled: false,
    notAuthourized: false,
    freezeCaptured: false,
    lang: "swe",
  };
  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>;
  componentDidMount() {
    const { dispatch, match, history } = this.props;
    let id = match.params.id;
    if (this.props.location.pathname.includes("/survey/")) {
      this.setState({ surveyCode: id }, () => {
        dispatch(formActions.getSurvey(/* parseInt( */ id /* , 36) */));
      });
    } else {
      dispatch(formActions.get(parseInt(id, 36), false, true));
    }
    let badgeNo = "";
    let loadOrder = "true";
    let lang = null;
    if (this.props.location.search) {
      const params = new URLSearchParams(this.props.location.search);
      badgeNo = params.get(getKey("badgeno", params));
      loadOrder = params.get(getKey("loadorder", params));
      lang = params.get(getKey("lang", params));
    }
    if (badgeNo) {
      this.setState({ badgeNo });
    }

    let searchParam = new URLSearchParams({}).toString();
    if (lang) {
      searchParam = new URLSearchParams({
        lang: lang,
      }).toString();
    }
    if (badgeNo) {
      let obj = {};

      if (lang) {
        obj.lang = lang;
      }

      obj.badgeNo = badgeNo;
      searchParam = new URLSearchParams(obj).toString();
    }

    this.setState({ lang: lang });
    history.push({
      pathname: match.url,
      search: "?" + searchParam,
    });

    dispatch(attendeeActions.getOrdersByBadgeNo(badgeNo));
    dispatch(cmsActions.setEnviroment(sourceTypes.FORM, false));
  }
  handleSearchParams = () => {
    if (this.props.location && this.props.location.search) {
      const { form, dispatch } = this.props;
      const params = new URLSearchParams(this.props.location.search);
      const page = params.get(getKey("page", params));
      const routeMaster = params.get(getKey("routemaster", params));
      const lang = params.get(getKey("lang", params));
      //Handle page navigation
      if (page && routeMaster == "true" && form.pages >= parseInt(page)) {
        dispatch(formActions.scrollPage(parseInt(page)));
      }
      if (lang) {
        const updatedForm = deepClone(form);
        updatedForm.languageCode = lang;

        dispatch(formActions.softUpdate(updatedForm));
        dispatch(cmsActions.setEnviromentLang(lang || updatedForm.languageCode));
      }
    }
    this.setState({ paramsHandled: true });
  };
  componentDidUpdate(prevProps) {
    if (this.props.form !== undefined && prevProps.form !== this.props.form && this.props.template === undefined) {
      const { form, history, match, dispatch } = this.props;
      if (form && form.templateId && !form.editMode) {
        //check if form is a survey
        document.title = form.eventName;

        if (form.survey === true && this.state.surveyCode === "") {
          //something has gone wrong
          this.setState({ disabled: true });
        }
        if (!this.state.paramsHandled) this.handleSearchParams();
        this.props.dispatch(templateActions.get(this.props.form.templateId));
      }
    }
    if (
      this.state.badgeNo &&
      this.props.attendee &&
      this.props.attendee.loading == false &&
      this.props.attendee.orders &&
      this.props.attendee.orders[0] &&
      !this.props.attendee.orders[0].badgeNo &&
      this.state.notAuthourized == false
    ) {
      this.setState({ notAuthourized: true });
    }

    if (this.props.form.currentPage !== prevProps.currentPage && this.state.paramsHandled) {
      const params = new URLSearchParams(this.props.location.search);
      const routeMaster = params.get(getKey("routemaster", params));
      if (routeMaster === "true" && !this.state.freezeCaptured) {
        document.dispatchEvent(new MessageEvent("FreezeFire"));
        this.setState({ freezeCaptured: true });
      }
    }
    if (this.props.form.formId > 0 && this.props.template !== undefined && this.props.template.content !== undefined && this.state.loaded === false) {

      if(this.props.form.settings && this.props.form.settings.googleAnalyticsId){
        var script1 = document.createElement("script");
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${this.props.form.settings.googleAnalyticsId.replace(" ", "")}`;
        script1.async = true;
        document.head.appendChild(script1);

        var script2 = document.createElement("script");
        script2.text = `window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', '${this.props.form.settings.googleAnalyticsId.replace(" ", "")}');`;

        document.head.appendChild(script2);
      }

      if (this.props.form.settings && this.props.form.settings.facebookId) {
        var script2 = document.createElement("script");
        script2.text = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${this.props.form.settings.facebookId.replace(" ", "")}');
        fbq('track', 'PageView');
      `;

        document.head.appendChild(script2);
      }

      document.body.style.height = "100vh";
      this.setState({ loaded: true });
      this.props.dispatch(conditionActions.checkAll());

      const params = new URLSearchParams(this.props.location.search);
      const lang = params.get(getKey("lang", params));
      if (lang != this.props.form.languageCode && !lang) {
        this.props.dispatch(cmsActions.setEnviromentLang(this.props.form.languageCode));

        let searchParam = new URLSearchParams({}).toString();

        searchParam = new URLSearchParams({
          lang: this.props.form.languageCode,
        }).toString();

        if (this.state.badgeNo) {
          let obj = {};

          obj.badgeNo = this.state.badgeNo;
          obj.lang = this.props.form.languageCode;
          searchParam = new URLSearchParams(obj).toString();
        }

        this.props.history.push({
          pathname: this.props.match.url,
          search: "?" + searchParam,
        });
        window.location.reload();
      }
    }
 /*    if(this.props.form && this.props.form.currentPage) */
  }
  render() {
    const { form, template } = this.props;
    const { loaded, notAuthourized } = this.state;
    if (notAuthourized)
      return (
        <NotAuthourized>
          <h1 style={{ fontFamily: "Be Vietnam" }}>
            <SystemLabel name="TheLinkIsNotValid" />
          </h1>
          <h4 style={{ fontFamily: "Be Vietnam", maxWidth: 500 }}>
            <SystemLabel name="TheLinkYouProvideIsNotValid" />
          </h4>
        </NotAuthourized>
      );
   
    if (
      this.state.badgeNo &&
      this.props.attendee &&
      this.props.attendee.loading == false &&
      this.props.attendee.orders &&
      this.props.attendee.orders[0] &&
      this.props.attendee.orders[0].badgeNo &&
      this.props.form.settings?.onlyGroupLeaderAllowedChangelink == true &&
      this.props.attendee.orders.length == 1 &&
      this.props.attendee.orders[0].orderGroupId &&
      this.props.attendee.orders[0].orderGroupId != this.props.attendee.orders[0].orderId
    ) {
      return (
        <NotAuthourized>
          <h1 style={{ fontFamily: "Be Vietnam" }}>
            <SystemLabel name="NotAllowed" />
          </h1>
          <h4 style={{ fontFamily: "Be Vietnam", maxWidth: 500 }}>
            <SystemLabel name="OnlyGroupLeaderCanChangeOrder" />
          </h4>
        </NotAuthourized>
      );
    }
    return (
      <React.Fragment>
        {!loaded ? <SplashScreen /> : null}
      
        {form && template ? (
          <div className="animated fadeIn">
        
            <DragDropContext>
              <div className="app">
                <div className="app-body" style={{ marginTop: "0px" }}></div>
                <main className="main not-inflicted" /* style={{margin: '0px !important'}} */>
                  <div className="animated fadeIn">
                    <Container fluid style={{ padding: "0px" }}>
                      <Suspense fallback={this.loading()}>
                        <TemplateWrapper>
                          <PostFormContent surveyCode={this.state.surveyCode} disabled={this.state.disabled} />
                        </TemplateWrapper>
                      </Suspense>
                    </Container>
                  </div>
                </main>
              </div>
            </DragDropContext>
          </div>
        ) : (
          this.loading()
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    event: state.event,
    template: state.template.template,
    form: state.form,
    attendee: state.attendee,
  };
}
export default connect(mapStateToProps)(PostFormLayout);
